import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '@app/shared/services/base.service';
import {VersionModel} from '@app/shared/model/VersionModel';
import {ConfirmationService, MessageService} from 'primeng/api';
import build from '../../../build';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class VersionService extends BaseService<VersionModel>{

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Inject(ConfirmationService) confirmationSrv: ConfirmationService,
    @Inject(MessageService) messageSrv: MessageService,
  ) {
    super('info', http, confirmationSrv, messageSrv);
  }

  async getInfoBackend() {
    return this.http.get<any>(`${this.urlBase}`).toPromise();
  }

  getInfoWeb(): VersionModel {

    const versionNumber = 'v' + build.version;
    const revision = build.git.fullHash;

    const dateFormat = 'DD/MM/YYYY HH:mm';
    const dateConverted = moment(build.timestamp).toDate();
    const buildDate = moment(dateConverted).format(dateFormat);

    return {
      buildDate,
      versionNumber,
      revision
    };
  }
}
